import { AnimCanvasProperty } from '../anim-constants';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import type { ComponentAnimWrapper } from '../../../canvas-render/elements/component-anim-wrapper';
import { IAnimFromStyleConverter } from './interface';
import { IFromStyle } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import { getFillColor, getFontColor, getFontSize, getLineColor } from '../anim-utils';

export default class AnimFromStyleConverter implements IAnimFromStyleConverter {
    private static instance: IAnimFromStyleConverter;
    public static getInstance(): IAnimFromStyleConverter {
        if (!this.instance) {
            this.instance = new AnimFromStyleConverter();
        }
        return this.instance;
    }

    private elementModel: IElementBaseModel;
    private animTarget: ComponentAnimWrapper;

    /**
     * 获取单个动画节点的初始样式
     * @param propNameList 动画需用到的属性名列表
     * @param animTarget 动画目标元素
     * @returns 动画的初始样式
     */
    public convertAnimFromStyle(propNameList: string[], animTarget: ComponentAnimWrapper): IFromStyle | undefined {
        this.elementModel = animTarget.factoryOptions.model;
        const fromStyle: IFromStyle = {};
        propNameList.forEach((propName) => {
            const propValue = this.getElementProperty(propName);
            if (!propValue) return;
            fromStyle[propName] = propValue;
        });
        return fromStyle;
    }


    /**
     * 获取动画目标元素的属性值
     * @param propName 属性名
     * @returns 属性值
     */
    private getElementProperty(propName: string): string | number | undefined {
        const handlers = {
            [AnimCanvasProperty.FILL_COLOR]: () => getFillColor(this.elementModel)?.rgba,
            [AnimCanvasProperty.LINE_COLOR]: () => getLineColor(this.elementModel)?.rgba,
            [AnimCanvasProperty.FONT_COLOR]: () => getFontColor(this.elementModel)?.rgba,
            [AnimCanvasProperty.FONT_SIZE]: () => getFontSize(this.elementModel),
            [AnimCanvasProperty.X]: () => this.animTarget?.x,
            [AnimCanvasProperty.Y]: () => this.animTarget?.y,
            [AnimCanvasProperty.ANGLE]: () => this.animTarget?.angle,
            [AnimCanvasProperty.ALPHA]: () => this.animTarget?.alpha,
            [AnimCanvasProperty.SCALE_X]: () => this.animTarget?.scaleX,
            [AnimCanvasProperty.SCALE_Y]: () => this.animTarget?.scaleY,
        };
        return handlers[propName]?.();
    }
}

export function getAnimFromStyleConverter(): IAnimFromStyleConverter {
    return AnimFromStyleConverter.getInstance();
}
